var lib_core = require("lib-core");
var editor_2d = require("editor-2d");

var DrillToolStateMachine = require("./drillToolStatemachine.js");

var DrillToolController = function(archLayers, dependencies, configuration) {
    this.setDefaultConfiguration({
        flip: 1,
        multiplePlacing: true,
        rotate: false
    });

    editor_2d.AbstractToolController.call(this, archLayers, dependencies, configuration);
};
lib_core.inherit(DrillToolController, editor_2d.AbstractToolController);
DrillToolController.inject = lib_core.clone(editor_2d.AbstractToolController.inject);

module.exports = DrillToolController;

DrillToolController.prototype.getButtonElements = function () {
    var buttonElements = {
        name: 'Drill',
        title: 'Drill Tool',
        style: {
            icon: 'icon-drill.svg',
        },
        eventData: {
            "tool": this.name()
        }
    };

    return buttonElements;
};

DrillToolController.prototype.createStateMachine = function () {
    var editorModel    = this.editor2DController.getModel();
    // TODO: we need to find a better way to get acces to these models
    var selectionModel = editorModel.selectionModel();

    return new DrillToolStateMachine(this.root, editorModel, selectionModel, this.getCollection(), this.configuration);
};
